<template>
  <div>
    <!-- {{ `currentSettings : ${JSON.stringify(currentSettings)}` }} -->
    <!-- {{transformListData(getDeviceCurrentSettings)}} -->
    <!-- <h3>Settings</h3> -->
    <!-- {{ getDeviceCurrentSettings }} -->
    <!-- state: {{getDeviceCurrentSettings[0].DeviceID}}
    <br />
    Params: {{deviceId}}-->
    <!-- <hr /> -->
    <div v-if="`${getDeviceCurrentSettings.DeviceID}` !== `${deviceId}`">
      No Current settings.
    </div>
    <div
      v-if="`${getDeviceCurrentSettings.DeviceID}` === `${deviceId}`"
      style="flex: 1;
                    display: flex;
                    align-items: center;
                    flex-flow: column;
                    justify-content: center;
                    padding: 10px;
                  "
    >
      <div
        class="inverterInfo"
        v-for="(dataKey, index) in Object.keys(getDeviceCurrentSettings)"
        v-show="dataKey != 'InverterId'"
        :key="`MiscData${index}`"
      >
        <b>{{ getLabel(dataKey) }}</b>
        <!-- <span>{{getDeviceCurrentSettings}}</span> -->
        <span>{{
          getDisplayValue(getDeviceCurrentSettings[dataKey], dataKey)
        }}</span>

        <!-- <span>{{getDeviceCurrentSettings[0][dataKeyMisc] +getUnit(Device.MiscData[dataKeyMisc],dataKeyMisc)}}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import moment from "moment";
// import { HTTP as IOTHTTP } from "@/store/actions";
import { mapGetters, mapActions } from "vuex";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import ElementControlNew from "./element-control-new";
import ElementControlRadio from "./element-control-radio";
import ElementPendingInfo from "./element-pending-info";

import payloadDictionary from "../../performance/payload_dictionary.json";

export default {
  name: "currentSettings",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "element-control-new": ElementControlNew,
    "element-control-radio": ElementControlRadio,
    "element-pending-info": ElementPendingInfo
  },
  props: {
    getDeviceCurrentSettings: {
      type: Object,
      default: {}
    }
  },
  computed: {
    // ...mapGetters(["getDeviceCurrentSettings", ""])
  },
  data: function() {
    return {
      showCanvas: false,
      pendingChanges: null,
      currentSettings: [],
      deviceId: "",
      optionsHolder: {
        OutputMode: [
          "Single Machine Output",
          "Parallel Output",
          "Phase 1 of 3 Phase output",
          "Phase 2 of 3 Phase Output",
          "Phase 3 of 3 Phase output"
        ],
        BatteryType: ["AGM", "Flooded battery", "For User Defined"],
        Chargersourcepriority: ["SBL UCD", "SBL UDC", "SLB UCD", "SLB UDC"],
        OutputSourcePriority: [
          "Utility - Solar - Battery",
          "Solar - Utility - Battery",
          "Solar - Battery - Utility"
        ],
        ACInputVoltageLoss: ["Appliance", "UPS"],
        Topology: ["Transformerless", "Transformer"],
        MachineType: ["Grid tie", "Off Grid", "Hybrid"],
        InputVoltage: ["Appliance", "UPS"]
      }
    };
  },
  methods: {
    getLabel(key) {
      // console.log(key);
      return payloadDictionary.find(x => x.new_key == key || x.old_key == key)
        ? payloadDictionary.find(x => x.new_key == key || x.old_key == key)[
            "label"
          ]
        : key;
    },
    getDisplayValue(value, key) {
      // let displayedData = singleInverter[key];

      let config = payloadDictionary.find(
        x => x.new_key == key || x.old_key == key
      );

      let unit = config ? config["unit"] : "";
      let dataType = config ? config["datatype"] : "";

      // console.log({ displayedData, dataType });
      //  displayedData.endsWith(unit) == false ? unit
      // if (dataType == "Boolean") {
      //   try {
      //     let tmpDisplayData = Number(displayedData);
      //     return tmpDisplayData == 0 ? "No" : "Yes";
      //   } catch (error) {}
      // }
      // console.log({ value, key, config, dataType, unit });

      if (dataType == "option") {
        try {
          let tmpDisplayData = Number(value);
          return this.optionsHolder[key][tmpDisplayData] || value;
        } catch (error) {}
      }
      if (value.toString().endsWith(unit) == true) {
        return value;
      }

      if (dataType == "Integer" || dataType == "Float") {
        try {
          let tmpDisplayData = Number(value);
          return tmpDisplayData != NaN ? tmpDisplayData + unit : value;
        } catch (error) {}
      }

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    transformListData(ListData) {
      return ListData.map(x => {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? this.transformListData(x) : this.transformMapData(x);
      });
    },
    transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return Object.keys(MapData).reduce((cummData, key) => {
        let oldKey = payloadDictionary.find(x => x.new_key == key);
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    async getPendingChanges() {
      const deviceId = this.$route.params.deviceId;

      const HTTP = this.$httpUtils.instance;
      const endpoint = `${this.$utilConstants.IOT_BASE_URL}/devicestate/`;

      const res = await HTTP.get(`${endpoint}${deviceId}`);
      if (
        res &&
        res.data &&
        res.data.state &&
        res.data.state.delta &&
        res.data.state.delta
      ) {
        return res.data.state.delta;
      }
    },
    async refresh() {
      this.pendingChanges = await this.getPendingChanges();
    }
  },
  created() {},
  async mounted() {
    this.deviceId = this.$route.params.deviceId;
    console.log({ geyGey: this.$route.params.deviceId });

    // this.currentSettings = await transformListData(getDeviceCurrentSettings);
    // this.pendingChanges = await this.getPendingChanges();
  }
};
</script>

<style lang="scss" scoped>
.inside {
  padding: 12px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.inverterInfo {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding: 5px;
  font-family: "Poppins", Arial, sans-serif;
  font-size: 10pt;
  cursor: pointer;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/controls/current-settings.vue